import React from "react";
import { DASH } from "../dashboardTheme";

const METRICS = [
  { key: "clientsActive", label: "Clientes" },
  { key: "branches", label: "Sucursales" },
  { key: "technicians", label: "Técnicos" },
  { key: "inventoryItems", label: "Stock total", suffix: " uds." },
  { key: "servicesThisMonth", label: "Servicios del mes", showMom: true },
];

function Skeleton() {
  return (
    <div className="dash-metrics-row">
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="dash-metric-cell">
          <div className="dash-skeleton" style={{ width: "55%", height: 28, marginBottom: 10 }} />
          <div className="dash-skeleton" style={{ width: "40%", height: 12 }} />
        </div>
      ))}
    </div>
  );
}

export default function MetricStrip({ kpis, loading, momChange }) {
  if (loading) return <Skeleton />;

  return (
    <div className="dash-metrics-row">
      {METRICS.map(({ key, label, suffix, showMom }) => {
        const value = kpis?.[key] ?? 0;
        const momPositive = momChange >= 0;
        const hasMom = showMom && momChange != null;

        return (
          <div key={key} className="dash-metric-cell">
            <div className="dash-metric-val">
              {value.toLocaleString("es-MX")}
              {suffix && (
                <span style={{ fontSize: "11px", color: DASH.textMuted, marginLeft: 4 }}>
                  {suffix}
                </span>
              )}
            </div>
            <div className="dash-metric-lbl">{label}</div>
            {hasMom && (
              <div
                className={`dash-metric-delta ${momPositive ? "dash-metric-delta--up" : "dash-metric-delta--down"}`}
              >
                {momPositive ? "↑" : "↓"} {Math.abs(momChange)}% vs mes anterior
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
